import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
//import { toBase64String } from "@angular/compiler/src/output/source_map";
import * as CryptoJS from "crypto-js";
import { PagerService } from "../../core/services/pager.service";

@Component({
  selector: "app-gateway",
  templateUrl: "./gateway.component.html",
  styleUrls: ["./gateway.component.css"],
})
export class GatewayComponent implements OnInit {
  public LoginEnterpriseID = "";
  public Role = "";
  GatewayList: any[];
  Countries: any[];
  Facilities: any[];
  updateFacilities: any[];
  successfulData;
  model;
  GatewayDetails;
  Device;
  gatewayform;
  DeviceTypeList;
  dataLoader: boolean;
  pager: any = {};
  private allItems: any[];
  pagedItems: any[];
  public country = "";
  public Type = "";
  public Country = "";
  public DeviceType;
  public _Country;
  IsgatewayAccess : boolean;

  //UI binding properties.

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute,
    private pagerService: PagerService
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;
    this._Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      // $location.path("/LoginInvalid");
      // $route.reload();
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit() {
    this.dataLoader = true;
    this.GatewayDetails = {
      Name: "",
      Country: "",
      Facility: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
    };

    //2023 requirement Removal of Gateway from config
    this.DeviceTypeList = [
      // {name: 'Skype',},
      { name: "Cisco" },
      // { name: 'Teams', }
    ];
    this.DeviceType = "Cisco";
    this.Device = "Cisco";
    // if(this.Role =="Regional Voice Admin" ||
    //    this.Role =="Global Admin" ||
    //    this.Role =="Gateway Access")
    // {
    $("#divGatewayDetailsCommon").css("display", "block");
    $("#divGatewaySubmit").css("display", "block");
    $("#divGatewayDetails").css("display", "block");
    $("#AlertForAccess").css("display", "none");
    // Method to fetch gateway Details
    this.LoadData();
    // }
    // else
    // {
    //   $("#divGatewayDetailsCommon").css("display", "none");
    //   $("#divGatewaySubmit").css("display", "none");
    //   $("#divGatewayDetails").css("display", "none");
    //   $("#AlertForAccessGateway").css("display", "block");
    // }
    

    this.successfulData = {
      ID1: "",
      Id: "",
      Name: "",
      Country: "",
      Facility: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
    };
    this.GetCountryList();
    this.GetGatewayListDropDown();
    this.AudiLogin();
  }
  

  // GetCountryList() {
  //   this.capservice.CountryList(this.gatewayform).subscribe(data => {
  //     this.Countries = data;
  //   });
  // }
  AudiLogin() {
    this.capservice
      .AudiLogin("Gateway", this.LoginEnterpriseID)
      .subscribe((data) => {});
  }
  GetCountryList() {
    this.capservice.CountryList(this.country, this.Type).subscribe((data) => {
      this.Countries = data;
    });
  }
  GetGatewayListDropDown() {
    this.capservice
      .GetVoiceAdminDetails(this.Device, "GatewayDropdown", this.country)
      .subscribe((data) => {
        this.GatewayList = data;
        this.dataLoader = false;
      });
  }
  GetFacility(Factype) {
    debugger;
    var country = '';
    if (Factype == 'Edit') {
      country = $('#grdCountry').val();
      this.capservice.FacilityList(country).subscribe(data => {
        this.Facilities = data;
      });
    } else {
      country = $("#grdfCountry").val();
      this.capservice.FacilityList(country).subscribe((data) => {
        this.Facilities = data;
      });
    }
    // this.capservice.FacilityList(country).subscribe(data => {
    //   this.Facilities = data;
    // });
  }
  //(change) = "DeviceTypeEvent($event)"
  DeviceTypeEvent(event: any) {
    this.ClearDevice();
    this.Device = event.target.value;

    if (
      this.Device == "Skype" ||
      this.Device == "Cisco" ||
      this.Device == "Teams"
    ) {
      $("#divGatewayDetailsCommon").css("display", "block");
      $("#divGatewaySubmit").css("display", "block");
      $("#divGatewayDetails").css("display", "block");
      $("#AlertForAccess").css("display", "none");

      // Method to fetch gateway Details
      this.LoadData();
    } else {
      $("#AlertForAccess").css("display", "block");
      $("#divGatewayDetailsCommon").css("display", "none");
      $("#divGatewaySubmit").css("display", "none");
      $("#divGatewayDetails").css("display", "none");
    }
  }
  LoadData() {
    this.capservice
      .GatewayList(this.Device, "Gateway", this.country)
      .subscribe((data) => {
        this.dataLoader = true;
        this.successfulData = { gateways: data, selected: {} };
        this.allItems = data;
        this.setPage(1);
        //this.GatewayList = data;
        this.GetGatewayListDropDown();
        this.dataLoader = false;
      });
  }
  ShowData() {
    debugger;
    var Country = '';

    if ($("#txtgateway").val() == "" && $("#dlstCountry").val() == "") {
      $("#divGatewayDetails").css("display", "none");
      alert("Please select value to search");
    } else {
      //Paginator.page = 0;
      if (this.Role != 'Global Admin') {
        Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
      }
      else { Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val(); }
      var gateway = $('#txtgateway').val() == '' ? 'N' : $('#txtgateway').val();

      if (this.Device == "Teams") {
        this.capservice
          .SearchDetailsTeamsGateway(
            "N",
            Country,
            gateway,
            this.Device,
            "Gateway"
          )
          .subscribe((data) => {
            if (data.length > 0) {
              this.successfulData = { gateways: data, selected: {} };
              this.allItems = data;
              // initialize to page 1
              this.setPage(1);
              //this.GatewayList = data;
              //this.GetGatewayListDropDown();
              $("#divGatewayDetails").css("display", "block");
            } else {
              alert("No Records Found");
              //this.clear();
              $("#divGatewayDetails").css("display", "none");
            }
          });
      } else {
        this.capservice
          .SearchDetails("N", Country, gateway, this.Device, "Gateway")
          .subscribe((data) => {
            if (data.length > 0) {
              this.successfulData = { gateways: data, selected: {} };
              this.allItems = data;
              // initialize to page 1
              this.setPage(1);
              //this.GatewayList = data;
              //this.GetGatewayListDropDown();
              $("#divGatewayDetails").css("display", "block");
            } else {
              alert("No Records Found");
              //this.clear();
              $("#divGatewayDetails").css("display", "none");
            }
          });
      }
    }
  }

  ExportToBulkExcel() {
    var Country = '';
    var ReportName = 'Gateway.xlsx';
      if (this.Role != 'Global Admin') {
        Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
    }
      else { Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val(); }
      var gateway = $('#txtgateway').val() == '' ? 'N' : $('#txtgateway').val();

    this.capservice
      .SearchDetailsBulkDownload("N", Country, gateway, this.Device, "Gateway")
      .subscribe(
        (data: Blob) => {
          this.dataLoader = true;
          if (data.size > 0) {
            if (
              window.navigator &&
              (window.navigator as any).msSaveOrOpenBlob
            ) {
              // for IE
              (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.dataLoader = false;
          }
            else{
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.dataLoader = false;
            }
          } else {
            alert("No Records Found");
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          this.dataLoader = false;
          alert("Acknowledgement failed");
        }
      );
  }
  GatewayAdd() {
    var message = '';
    if ($('#grdfGateway').val() == '') {
      message = "Please Enter Gateway Name";
    }
    if ($("#grdfCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdfFacility").val() == "") {
      message = message + "\n" + "Please Select Facility";
    }
    if ($("#grdfActive").val() == "") {
      message = message + "\n" + "Please Select Active";
    }
    if (this.Device == "") {
      message = message + "\n" + "Please Select DeviceType";
    }
    if (message != "") {
      //this.clear();
      alert(message);
    } else {
      debugger;
      this.GatewayDetails.DeviceType = this.Device;
      this.GatewayDetails.EnterpriseID = this.LoginEnterpriseID;
      this.GatewayDetails.strType = "Gateway";

      this.capservice
        .InsertVoiceAdminDetails(this.GatewayDetails)
        .subscribe((data: any) => {
          if (data.toString() == "Gateway Already Exists") {
            alert(data);
            this.clear();
            this.GetFacility("Display");
          } else {
            alert(data);
            this.clear();
          }
        });
    }
  }
  EditGateway(Gateway) {
    this.successfulData.selected = Object.assign({}, Gateway);
    this.capservice
      .FacilityList(this.successfulData.selected.Country)
      .subscribe((data) => {
        this.Facilities = data;
      });
  }
  GatewayUpdate(Gateway) {
    var message = '';
    if ($('#grdGateway').val() == '') {
      message = "Please Enter Gateway Name";
    }
    if ($("#grdCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdFacility").val() == "") {
      message = message + "\n" + "Please Select Facility";
    }
    if ($("#grdActive").val() == "") {
      message = message + "\n" + "Please Select Active";
    }
    if (this.Device == "") {
      message = message + "\n" + "Please Select DeviceType";
    }
    if (message != "") {
      alert(message);
    } else {
      this.successfulData.selected.ID1 =
        this.successfulData.selected.Id.toString();
      this.successfulData.selected.Id = this.successfulData.selected.Id;
      this.successfulData.selected.DeviceType = this.Device;
      this.successfulData.selected.strType = "Gateway";
      this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;

      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data: any) => {
          if (data == "Gateway Already Exists") {
            alert(data);
            this.clear();
          } else {
            alert(data);
            this.clear();
          }
        });
    }
  }
  DeleteGateway(Gateway) {
    debugger;
    this.capservice
      .DeleteVoiceAdminDetails(
        Gateway.Id,
        "Gateway",
        this.LoginEnterpriseID,
        ""
      )
      .subscribe((data) => {
        alert(data);
        this.clear();
      });
  }
  ClearDevice() {
    $("#grdfGateway").val("");
    $("#grdfFacility").val("");
    $("#grdfCountry").val("");
    $("#grdfActive").val("");
    $("#grdGateway").val("");
    $("#grdFacility").val("");
    $("#grdCountry").val("");
    $("#grdActive").val("");
    $("#dlstCountry").val("");
    $("#txtgateway").val("");
  }
  clear() {
    $("#grdfGateway").val("");
    $("#grdfFacility").val("");
    $("#grdfCountry").val("");
    $("#grdfActive").val("");
    $("#grdGateway").val("");
    $("#grdFacility").val("");
    $("#grdCountry").val("");
    $("#grdActive").val("");
    $("#dlstCountry").val("");
    $("#txtgateway").val("");
    // this.DeviceTypeList();
    $("#divGatewayDetails").css("display", "block");
    this.LoadData();
  }
  reset() {
    this.successfulData.selected = {};
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    // get current page of items
    this.successfulData.gateways = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
